import { Address, CreateAddress, UpdateAddress } from "../../../address/types/models/Address";
import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity Buyers


export interface Buyer {
    id: ID;

    
    name: string;

    
    description?: string;

    
    vatId?: string;

    
    iban?: string;

    
    bank?: string;

    
    scopeGroupId: ID;

    
    swift?: string;

    
    buyerScopeGroupId: ID;

    
    addressIdAddress?: Address;
    

    }




export interface CreateBuyer {
    
    name: string;

    
    description?: string;

    
    vatId?: string;

    
    iban?: string;

    
    bank?: string;

    
    
    swift?: string;

    
    
    addressIdAddress?: CreateAddress;
    

    }


export interface UpdateBuyer {
    
    name: string;

    
    description?: string;

    
    vatId?: string;

    
    iban?: string;

    
    bank?: string;

    
    
    swift?: string;

    
    
    addressIdAddress?: UpdateAddress;
    

    }

export interface PresentationBuyerRequest {
    list: ListRequest,
    filter: {
        name: string,
        nameOr: boolean,
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryBuyer {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: Buyer): PrimaryBuyer | undefined {
        return entity ? new PrimaryBuyer(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryBuyer {
        return new PrimaryBuyer(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryBuyer {
        let vals = path?.split('/');
        return new PrimaryBuyer(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryBuyer[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: Buyer): string {
    let fields = entity ? [
    entity.name,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityBuyer {
    id: PrimaryBuyer;
    data: UpdateBuyer;


    constructor(id: PrimaryBuyer, data: UpdateBuyer) {
        this.id = id;
        this.data = data;
    }
}
